import { TYPE_REPORT } from 'Src/constants/TypeReport'

export const Access = {
	reports: {
		orders: 'reports.orders',
		small_orders: 'reports.small_orders',
		unblock_requests: 'reports.unblock_requests',
		[TYPE_REPORT.EVENTS_UNBLOCK_REQUESTS]: 'reports.events_unblock_requests',
		call_requests: 'call_easy_reports.call_requests',
		blocks: 'call_easy_reports.blocks',
		black_lists: 'call_easy_reports.black_lists',
		rbidos_customers: 'reports.rbidos_requests',
		[TYPE_REPORT.EVENTS_USERS]: 'reports.events_users',
		[TYPE_REPORT.EVENTS_REPORTS]: 'reports.reports',
		[TYPE_REPORT.EVENTS_RBIDOS_REQUESTS]: 'reports.events_rbidos_requests',
		[TYPE_REPORT.EVENTS_PARTNERS]: 'reports.events_partners',
		[TYPE_REPORT.EVENTS_ORDERS]: 'reports.events_orders',
		[TYPE_REPORT.EVENTS_CUSTOMER_IDENTIFICATIONS]: 'reports.events_customer_identifications',
		[TYPE_REPORT.EVENTS_PRODUCTS]: 'reports.events_products',
		[TYPE_REPORT.STATISTICS]: 'reports.statistics',
		[TYPE_REPORT.NEPAL_ACTS]: 'nepal_act_reports.acts',
		[TYPE_REPORT.COLISEUM_STATISTICS]: 'call_easy_reports.call_request_statistics',
		[TYPE_REPORT.RBIDOS_REQUEST_STATISTICS]: 'reports.rbidos_request_statistics',
		[TYPE_REPORT.CLICK_THROUGH]: 'reports.click_through',
		[TYPE_REPORT.STATISTICS_NEO]: 'reports.neo_statistics',
		[TYPE_REPORT.BG_REQUEST_STATISTICS]: 'bg_reports.request_statistics',
		[TYPE_REPORT.SDEX_LOGS]: 'reports.sber_big_data_logs',
		leads: 'reports.leads',
		sms: 'reports.sms',
		nepal_reports: 'nepal_reports.acts',
		partners_registry: 'reports.partners_registry',
		[TYPE_REPORT.PARTNER_CONTRACTS]: 'reports.partner_contracts',
		[TYPE_REPORT.DEPARTMENTS]: 'reports.departments',
		[TYPE_REPORT.ORDER_TASKS_LOGS]: 'reports.task_model',
		ord_reports: 'ord_reports.creative_payments',
		[TYPE_REPORT.USERS_API]: 'reports.users_api',
		[TYPE_REPORT.SELF_EMPLOYED_LOGS]: 'reports.self_employed_logs',
		[TYPE_REPORT.SBER_DEPARTMENTS]: 'reports.sber_departments',
		[TYPE_REPORT.CALL_EASY_NEW_REGISTRATION]: 'reports.call_easy_new_registration',
		[TYPE_REPORT.SEARCH_CLIENT]: 'reports.search_client',
		[TYPE_REPORT.PARTNER_ANTIFRAUD]: 'reports.partner_antifrauds',
		[TYPE_REPORT.INFOTECS_REQUESTS]: 'reports.infotecs_requests',
		[TYPE_REPORT.EVENTS_DEPARTMENTS]: 'reports.events_departments',
		[TYPE_REPORT.EVENTS_CUSTOMER_IDENTIFICATIONS_DOCUMENT_PREDICTIONS]:
			'reports.events_customer_identifications_document_predictions',
		[TYPE_REPORT.BG_CALCULATE_COMMISSION]: 'bg_reports.calculate_commission',
		[TYPE_REPORT.CSAT_METRICS]: 'reports.csat_metrics',
		[TYPE_REPORT.OPEN_SOURCE_REQUESTS]: 'bg_reports.open_source_requests',
		[TYPE_REPORT.BLANK_REGISTRATION_DATE_ORDERS]: 'reports.events_order_blank_registration_date',
		[TYPE_REPORT.SVETOFOR_REQUESTS]: 'reports.svetofor_requests',
		[TYPE_REPORT.PARTNER_BIRTHDAYS]: 'reports.partner_birthdays',
		[TYPE_REPORT.USERS]: 'reports.users',
	},
	lead_pro: {
		lead_show: 'lead.show',
		mass_updater: 'mass_updater.leads_with_violation',
		mass_updater_file: 'lead.change_status_from_file',
	},
	sber_mq_order: {
		contact_details: 'sber_mq_order.contact_details',
		create: 'sber_mq_order.create',
		cancel_mass_assign_crm: 'sber_mq_product_order_relation.cancel_mass_assign_crm',
	},
	sber_mq_external_form: {
		index: 'sber_mq_external_form.index',
	},
	dashboard: {
		data_presenter: {
			index: 'dashboard_data_presenter.index',
		},
		news: {
			create: 'dashboard_news.create',
			destroy: 'dashboard_news.destroy',
			update: 'dashboard_news.update',
		},
	},
	partner: {
		index: 'partner.index',
		svetofor: 'partner.svetofor_ul_info',
		motivation: 'partner.motivation',
	},
	user: {
		index: 'user.index',
		show_sbbol_attach_btn: 'user.show_sbbol_attach_btn',
		infotecs_login: 'user.infotecs_login',
		create: 'user.create',
		edit: 'user.edit',
		destroy: 'user.destroy',
		resend_api_token: 'user.resend_api_token',
	},
	company: {
		index: 'company.index',
	},
	nepal_acts: {
		upload_acts: 'nepal_act.upload',
		upload_reestr: 'nepal_act.build_from_file',
		upload_promotion_reestr: 'nepal_act.build_promotion_from_file',
		upload_paids: 'nepal_act.upload_paids',
		cancel_paids: 'nepal_act.cancel_paids',
		ds_sign: 'nepal_act.ds_sign',
		partner_sign: 'nepal_act.partners_sign',
		on_partner_sign: 'nepal_act.on_partner_sign',
		cancel: 'nepal_act.cancel',
		delete: 'nepal_act.delete',
		set_status: 'nepal_act.set_status',
		restore: 'nepal_act.restore',
		sms_code_clear: 'nepal_sms_code.clear',
		unblock: 'nepal_act.unblock',
		generate_protocol: 'nepal_act.generate_protocol',
		refund: 'nepal_act.refund',
		remark: 'nepal_act.remark',
		collection_archive: 'nepal_act.collection_archive',
		partner_can_sign: 'nepal_act.partner_can_sign',
		send_refund_emails: 'nepal_act.send_refund_emails',
		file: 'nepal_act.file',
		sber_confirmation: 'nepal_reports.sber_confirmation',
		upload_payment_orders: 'nepal_act.upload_payment_orders',
		upload_third_party_acts_and_invoices: 'nepal_act.upload_third_party_acts_and_invoices',
		update_status: 'nepal_act.update_status',
		annul_request: 'nepal_act.annul_request',
	},
	survey: {
		create: 'exam_survey.create',
		get_full_report: 'reports.survey_results_full',
	},
	infotecs_request: {
		check_infotecs_status: 'infotecs_request.check_infotecs_status',
		resend_sms: 'infotecs_request.resend_sms',
		show: 'infotecs_request.show',
		logs: 'infotecs_request.logs',
		update: 'infotecs_request.update',
	},
	customer_identification: {
		passport_data: 'customer_identification.passport_data',
		template: 'customer_identification.template',
	},
	rbidos_request: {
		offline_identification: 'rbidos_request.offline_identification',
		logs: 'rbidos_request.support_info',
	},
	notification_templates: {
		index: 'notification_template.index',
	},
	order: {
		create: 'order.create',
	},
	call_easy: {
		call_request: {
			update: 'call_easy_call_request.update',
		},
	},
	sber_mq_product: {
		index: 'sber_mq_product.index',
	},
	channel: {
		create: 'channel.create',
		delete: 'channel.destroy',
		edit: 'channel.update',
	},
	broker: {
		update: 'bg_request.update',
		create_commercial: 'bg_request.create_commercial',
		support_info: 'bg_request.support_info',
		current_elements: 'bg_request.current_elements',
		bg_reports: 'bg_reports.requests',
		bg_reports_extended_statistics: 'bg_reports.extended_statistics',
		full_request_data: 'bg_request.full_request_data',
		document: 'bg_document.file',
		tmpp_filters: 'bg_request.tb_tmpp_filter',
		agents_commission: 'bg_request.display_agent_comission',
		limit_requst_support_info: 'bg_limit_request.support_info',
		limit_request_create: 'bg_limit_request.create',
		limit_request_index: 'bg_limit_request.index',
		limit_request_show: 'bg_limit_request.show',
		limit_request_update: 'bg_limit_request.update',
		bg_gov_private: 'bg_gov_private.create',
		bg_gov_single_supplier: 'bg_gov_single_supplier.create',
		bg_commercial_direct_create: 'bg_commercial_direct.create',
		assign: 'bg_request.assign',
		bg_notification: 'user_setting.bg_notification',
		bg_limit_request_get_client_limit: 'bg_limit_request.get_client_limit',
		bg_sbbol_create: 'bg_sbbol.create',
		bg_svetofor_check: 'bg_svetofor_check.show',
		bg_publication: 'bg_publication.show',
		request_new_lead: 'bg_request.request_new_lead',
	},
	reference_book: {
		city: {
			update: 'sber_mq_city.update',
			destroy: 'sber_mq_city.destroy',
			restore: 'sber_mq_city.restore',
		},
	},
	contracts_registry: {
		edit: 'partner_registry.update',
		massUpdate: 'mass_updater.partner',
		delete: 'partner_contract.destroy',
		notify_contract: 'partner.notify_contract_limit_remainder',
	},
	department: {
		index: 'department.index',
		create: 'department.create',
		update: 'department.update',
	},
	partner_request: {
		create: 'partner_request.create',
		update: 'partner_request.update',
		comment: 'partner_request.comment',
		resume: 'partner_request.resume',
		report: 'reports.partner_requests',
		mass_create: 'partner_request.mass_create',
	},
	special_offer: {
		index: 'special_offer.index',
	},
	uni_chat: {
		order_token: 'uni_chat.order_token',
		general_token: 'uni_chat.general_token',
		order_chat_write: 'uni_chat.order_chat_write',
	},
	order_task: {
		index: 'order_task.index',
		complete: 'order_task.complete',
		revert_complete: 'order_task.revert_complete',
		stats: 'order_task.stats',
		order_task_event: 'order_task_event.index',
		training_showed: 'order_task.training_showed',
		task_model_logo_clicked: 'order_task.task_model_logo_clicked',
	},

	advert: {
		update: 'ord_creative.update',
		org_update: 'ord_organization.update',
	},
	landing: {
		create: 'landing.create',
		show: 'landing.show',
		update: 'landing.update',
		destroy: 'landing.destroy',
	},
	lead: {
		index: 'lead.index',
	},
	user_document: {
		index: 'user_document.index',
		create: 'user_document.create',
		destroy: 'user_document.destroy',
	},
	transition: {
		view_partner: 'transition.from_partners_registry_to_partners_section',
		view_user: 'transition.from_partners_registry_to_users_section',
		view_registry: 'transition.from_users_to_partner_registry_section',
	},
}
